'use strict';

import { completeTicketComponent, completeTicketRoute } from './completeTicket/completeTicket.component';
import { decipherSurveyComponent, decipherSurveyRoute } from './decipherSurvey/decipherSurvey.component';
import { decipherSurveyRedirectComponent, decipherSurveyRedirectRoute } from './decipherSurvey/decipherSurveyRedirect.component';
import { entryPointComponent, entryPointRoute } from './entryPoint/entryPoint.component';
import { errorComponent, errorRoute } from './error/error.component';
import { flyinComponent, flyinRoute } from './flyin/flyin.component';
import { footerComponent } from './footer/footer.component';
import { homeComponent, homeRoute } from './home/home.component';
import { redirectComponent, redirectRoute } from './redirect/redirect.component';
import { testFinalComponent, legacyTestFinalRoute, testFinalRoute } from './test/final.component';
import { ticketCompletedComponent, ticketCompletedRoute } from './ticketCompleted/ticketCompleted.component';
import { networkTestComponent, networkTestRoute } from './networkTest/networkTest.component';
import { anywhereComponent, anywhereRoute, anywhereMobileRoute, anywherMobileReturnRoute } from './anywhere/anywhere.component';
import { modelViewComponent, modelViewRoute } from './modelView/modelView.component';

import { baseStepController } from './base.step.controller';
import { d365RedirectComponent, d365RedirectRoute } from './redirect/d365Redirect.component';
import { externalEcommerceComponent, externalEcommerceRoute } from './externalEcommerce/externalEcommerce.component';
import { externalEcommercePassbackComponent, externalEcommercePassbackRoute } from './externalEcommerce/externalEcommercePassback.component';

var stepRoute = {
    params: {
        executionStep: null,
        ticketId: null,
        stepId: null
    }
};

function makeStepRoute(route) {
    var newRoute = angular.extend(route, stepRoute);
    if (!newRoute.url.includes(':ticketId')) newRoute.url += '/:ticketId';
    if (!newRoute.url.includes(':stepId')) newRoute.url += '/:stepId';

    return newRoute;
}

export default function (app) {
    app
        //add components here
        .component(completeTicketComponent.name, completeTicketComponent)
        .component(decipherSurveyComponent.name, decipherSurveyComponent)
        .component(decipherSurveyRedirectComponent.name, decipherSurveyRedirectComponent)
        .component(entryPointComponent.name, entryPointComponent)
        .component(errorComponent.name, errorComponent)
        .component(flyinComponent.name, flyinComponent)
        .component(footerComponent.name, footerComponent)
        .component(homeComponent.name, homeComponent)
        .component(networkTestComponent.name, networkTestComponent)
        .component(redirectComponent.name, redirectComponent)
        .component(d365RedirectComponent.name, d365RedirectComponent)
        .component(externalEcommerceComponent.name, externalEcommerceComponent)
        .component(externalEcommercePassbackComponent.name, externalEcommercePassbackComponent)
        .component(testFinalComponent.name, testFinalComponent)
        .component(ticketCompletedComponent.name, ticketCompletedComponent)
        .component(anywhereComponent.name, anywhereComponent)
        .component(modelViewComponent.name, modelViewComponent)

        //add stand-alone controllers here
        .controller('baseStepController', baseStepController)

        .config(['$stateProvider', function ($stateProvider) {
            //add routes here
            $stateProvider.state(completeTicketRoute);
            $stateProvider.state(makeStepRoute(decipherSurveyRoute));
            $stateProvider.state(decipherSurveyRedirectRoute);
            $stateProvider.state(entryPointRoute);
            $stateProvider.state(errorRoute);
            $stateProvider.state(makeStepRoute(flyinRoute));
            $stateProvider.state(homeRoute);
            $stateProvider.state(makeStepRoute(networkTestRoute));
            $stateProvider.state(makeStepRoute(redirectRoute));
            $stateProvider.state(makeStepRoute(d365RedirectRoute));
            $stateProvider.state(makeStepRoute(externalEcommerceRoute));
            $stateProvider.state(externalEcommercePassbackRoute);
            $stateProvider.state(testFinalRoute);
            $stateProvider.state(legacyTestFinalRoute);
            $stateProvider.state(ticketCompletedRoute);
            $stateProvider.state(makeStepRoute(anywhereRoute));
            $stateProvider.state(anywhereMobileRoute);
            $stateProvider.state(anywherMobileReturnRoute);
            $stateProvider.state(modelViewRoute);
        }]);
}